import { FETCH_LAYERS_SUCCESS } from '../layers/Types';

import {
    SET_FORM_PROPERTIES,
    SET_AREA_FACET,
    SET_AREA_FACET_VALUE,
    SET_AREA_GEOJSON,
    SET_AREA_CRITERIA,
    SET_AREA_LAYER
} from '../search_area/Types';

import {
    SET_IS_OWNERSHIP_RESULTS_EXPANDED,
    START_OWNERSHIP_SEARCH_REQUEST,
    START_OWNERSHIP_SEARCH_SUCCESS,
    START_OWNERSHIP_SEARCH_FAILURE,
    FETCH_OWNERSHIP_SEARCH_REQUEST,
    FETCH_OWNERSHIP_SEARCH_SUCCESS,
    FETCH_OWNERSHIP_SEARCH_FAILURE,
    PING_OWNERSHIP_SEARCH_REQUEST,
    PING_OWNERSHIP_SEARCH_SUCCESS,
    PING_OWNERSHIP_SEARCH_FAILURE,
    CANCEL_OWNERSHIP_SEARCH_REQUEST,
    CANCEL_OWNERSHIP_SEARCH_SUCCESS,
    CANCEL_OWNERSHIP_SEARCH_FAILURE,
    FETCH_OWNERSHIP_SEARCH_RESULTS_REQUEST,
    FETCH_OWNERSHIP_SEARCH_RESULTS_SUCCESS,
    FETCH_OWNERSHIP_SEARCH_RESULTS_FAILURE
} from './Types';

import { OWNERSHIP_REDUCER } from '../ReducerNames';
import areaReducer from '../search_area/Reducer';
import {
    IOwnershipAction,
    IOwnershipReducerState,
    OwnershipResults
} from './ownershipTypes';

const defaultState = {
    isSearching: false,
    isFetching: false,
    isPinging: false,
    isCancelling: false,

    search: null, // The current search running in the background
    results: [],
    start: 0,
    end: null,
    isSearchDirty: false,
    isLoadingResults: false,
    isResultsExpanded: false,

    ownershipSearchArea: {
        ...areaReducer(OWNERSHIP_REDUCER)(undefined, {}),
        facetId: 16,
        layerId: null
    }
};

export default function reducer(
    state: IOwnershipReducerState = defaultState,
    action: IOwnershipAction
) {
    switch (action.type) {
        case SET_IS_OWNERSHIP_RESULTS_EXPANDED:
            return {
                ...state,
                isResultsExpanded: action.isExpanded
            };
        case START_OWNERSHIP_SEARCH_REQUEST:
            return {
                ...state,
                isSearching: true,
                search: null,
                error: null,
                results: [],
                isResultsExpanded: false,
                start: 0,
                end: null
            };
        case START_OWNERSHIP_SEARCH_SUCCESS:
            return {
                ...state,
                search: action.search,
                isSearchDirty: false,
                error: null
            };
        case START_OWNERSHIP_SEARCH_FAILURE:
            return {
                ...state,
                isSearching: false,
                error: action.error
            };
        case FETCH_OWNERSHIP_SEARCH_REQUEST:
            return {
                ...state,
                isFetching: true,
                isSearching: false,
                isPinging: false,
                search: null, // Looks cleaner clearing at moment, may be best to leave in case user cancels so previous results are retained?
                error: null,
                results: [],
                isResultsExpanded: false,
                start: 0,
                end: null
            };
        case FETCH_OWNERSHIP_SEARCH_SUCCESS:
            return {
                ...state,
                isFetching: false,
                isSearching: ['ready', 'queued', 'running'].includes(
                    action.search.status
                ),
                search: action.search,
                isSearchDirty: false,
                areaType: 'drawn',
                ownershipSearchArea: {
                    isDirty: false,
                    geojson: { geometry: action.search.area },
                    facetId: action.search.areaFacet.id,
                    facetValue: action.search.areaFacetValue,
                    facetValid: true,
                    criteria: action.search.criteria,
                    layerId: action.search.layerId
                },
                error: null
            };
        case FETCH_OWNERSHIP_SEARCH_FAILURE:
            return {
                ...state,
                isFetching: false,
                error: action.error
            };
        case PING_OWNERSHIP_SEARCH_REQUEST:
            return {
                ...state,
                isPinging: true,
                error: null
            };
        case PING_OWNERSHIP_SEARCH_SUCCESS:
            return {
                ...state,
                isSearching: ['ready', 'queued', 'running'].includes(
                    action.search.status
                ),
                isPinging: false,
                search: action.search,
                error:
                    action?.search?.computedData &&
                    action?.search?.computedData?.error
                        ? action.search.computedData.error
                        : null
            };
        case PING_OWNERSHIP_SEARCH_FAILURE:
            return {
                ...state,
                isSearching: false,
                isPinging: false,
                error: action.error
            };
        case CANCEL_OWNERSHIP_SEARCH_REQUEST:
            return {
                ...state,
                isCancelling: true,
                error: null
            };
        case CANCEL_OWNERSHIP_SEARCH_SUCCESS:
            return {
                ...state,
                isSearching: false,
                isPinging: false,
                isCancelling: false,
                isSearchDirty: true,
                search: null,
                error: null
            };
        case CANCEL_OWNERSHIP_SEARCH_FAILURE:
            return {
                ...state,
                isCancelling: false,
                error: action.error
            };

        case FETCH_OWNERSHIP_SEARCH_RESULTS_REQUEST:
            return {
                ...state,
                start: action.start,
                end: action.end,
                isLoadingResults: true
            };
        case FETCH_OWNERSHIP_SEARCH_RESULTS_SUCCESS:
            return {
                ...state,
                results: [...(state.results as OwnershipResults), ...action.results],
                isLoadingResults: false
            };
        case FETCH_OWNERSHIP_SEARCH_RESULTS_FAILURE:
            return {
                ...state,
                error: action.error,
                isLoadingResults: false
            };

        case SET_FORM_PROPERTIES:
        case SET_AREA_FACET:
        case SET_AREA_FACET_VALUE:
        case SET_AREA_GEOJSON:
        case SET_AREA_CRITERIA:
        case SET_AREA_LAYER:
            return action.reducerName === OWNERSHIP_REDUCER
                ? {
                      ...state,
                      isSearchDirty: true,
                      ownershipSearchArea: areaReducer(OWNERSHIP_REDUCER)(
                          state.ownershipSearchArea,
                          action
                      )
                  }
                : state;
        case FETCH_LAYERS_SUCCESS:
            return {
                ...state,
                isSearchDirty: true,
                ownershipSearchArea: areaReducer(OWNERSHIP_REDUCER)(
                    state.ownershipSearchArea,
                    action
                )
            };
        default:
            return state;
    }
}
